export enum ActionWorkflowNode {
    Reprint = 'reprint',
    UpgradeToVeneers = 'upgradetoveneers',
    Redesign = 'redesign'
}
